import { render } from "./MultipleCheckboxWithAudio.vue?vue&type=template&id=37274d30"
import script from "./MultipleCheckboxWithAudio.vue?vue&type=script&lang=js"
export * from "./MultipleCheckboxWithAudio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/MultipleCheckboxWithAudio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37274d30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37274d30', __exports__)) {
    api.reload('37274d30', __exports__)
  }
  
  module.hot.accept("./MultipleCheckboxWithAudio.vue?vue&type=template&id=37274d30", () => {
    api.rerender('37274d30', render)
  })

}


export default __exports__